import type {
  PlotItem,
  CastItem,
  ReviewItem,
  NewsItem,
  Recommendation,
} from "@/types/content";

export const showInfo = {
  name: "我的朋友他的妻子",
  tagline: "在遗忘与铭记之间，重新认识爱",
  genre: "都市情感 · 悬疑 · 剧情",
  year: "2026",
  episodes: "全 24 集",
  director: "沈聿",
  writer: "周砚清",
  rating: "8.7",
  heroCover:
    "https://readdy.ai/api/search-image?query=Cinematic%20dramatic%20scene%20of%20an%20elegant%20woman%20standing%20by%20deep%20crimson%20red%20velvet%20curtains%20in%20a%20dimly%20lit%20luxurious%20room%2C%20warm%20moody%20amber%20lighting%2C%20emotional%20atmosphere%2C%20film%20noir%20style%2C%20shallow%20depth%20of%20field%2C%20high%20contrast%2C%20artistic%20and%20refined&width=1600&height=900&seq=mwtn-hero-01&orientation=landscape",
  posterCover:
    "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20style%20portrait%20of%20a%20thoughtful%20young%20woman%20and%20a%20man%20standing%20apart%20in%20a%20warm%20dim%20room%2C%20deep%20crimson%20and%20amber%20color%20palette%2C%20melancholic%20emotional%20mood%2C%20soft%20dramatic%20lighting%2C%20elegant%20artistic&width=600&height=900&seq=mwtn-poster-01&orientation=portrait",
  intro:
    "一场十年前被遗忘的雨夜，让苏晴与顾言之间那段无人知晓的往事重新浮出水面。当记忆的碎片被逐一拾起，每个人都不得不面对自己曾经的选择。《我的朋友他的妻子》以细腻的镜头与克制的叙事，讲述了一段关于爱与遗忘的故事。",
  watchNote: "你上次观看到第 7 集 · 还剩约 12 分钟",
};

export const plotItems: PlotItem[] = [
  {
    id: "plot-1",
    type: "plot",
    title: "雨夜重逢：十年后的第一面",
    chapter: "第 1 集",
    tags: ["主线", "回忆"],
    order: 1,
    summary:
      "十年后的第一场大雨，苏晴在旧书店门外与顾言不期而遇。两人都没有开口，却都记得那个没有说完的夜晚。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20two%20figures%20meeting%20outside%20a%20vintage%20bookstore%20in%20heavy%20rain%20at%20night%2C%20warm%20street%20lamp%20glow%2C%20deep%20red%20umbrella%2C%20moody%20emotional%20atmosphere%2C%20soft%20blurred%20city%20lights&width=800&height=500&seq=mwtn-plot-01&orientation=landscape",
    updatedAt: "2026-05-21",
    content: [
      "第一集以一场持续整夜的大雨开场。镜头从老城区的屋檐缓缓下落，落在旧书店门口那道被雨水打湿的台阶上。苏晴抱着一摞旧书，正准备关门，转身却看见撑着黑伞的顾言站在雨里。",
      "导演没有给他们任何台词。两个人只是隔着雨幕对望了三秒钟，这三秒钟却像被拉长了十年。观众能清楚地感受到，这两人之间一定发生过什么，而且是那种一旦提起就会疼痛的往事。",
      "本集最重要的信息隐藏在片尾的一段闪回里：十年前同样的雨夜，一台老式收音机播放着走调的歌，桌上摆着两只没有用完的茶杯。画面到此戛然而止，留下一个巨大的悬念——那晚究竟发生了什么？",
      "值得一提的是，场景中的旧书店并非单纯的背景，它将在后续剧情中反复出现，成为串联两条时间线的关键空间。",
    ],
  },
  {
    id: "plot-2",
    type: "plot",
    title: "旧信笺中的名字",
    chapter: "第 2 集",
    tags: ["回忆", "支线"],
    order: 2,
    summary:
      "整理母亲遗物时，苏晴在一本旧书里发现了一封从未寄出的信，落款处的名字让她彻夜难眠。",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20cinematic%20shot%20of%20a%20yellowed%20handwritten%20letter%20and%20a%20vintage%20book%20on%20a%20wooden%20desk%2C%20warm%20afternoon%20light%20through%20sheer%20curtains%2C%20dust%20particles%20in%20the%20air%2C%20nostalgic%20quiet%20mood&width=800&height=500&seq=mwtn-plot-02&orientation=landscape",
    updatedAt: "2026-05-22",
    content: [
      "第二集把视角收进室内。苏晴回到母亲留下的老房子，在一只落满灰的木箱里整理遗物。这里的镜头语言极其克制，缓慢移动的横轴镜头让空间显得空旷而寂寞。",
      "转折发生在书的夹页里。一封没有贴上邮票、没有写收信人的信掉了出来，信纸边缘已经发脆。落款处是一个她无比熟悉、却又多年没有听人提起的名字。",
      "本集通过这封信，第一次向观众透露了两个家庭之间隐秘的联系。信中的语气温柔而犹豫，字里行间都是说不出口的歉意，这为后续的真相埋下了重要线索。",
      "片尾，苏晴坐在窗前坐到天亮。她没有哭，只是反复摩挲着那行字。这个克制的细节被称为本集最打动人的瞬间。",
    ],
  },
  {
    id: "plot-3",
    type: "plot",
    title: "办公室里的暗流",
    chapter: "第 3 集",
    tags: ["支线"],
    order: 3,
    summary:
      "周芸以新同事身份进入苏晴的公司，一次看似平常的部门会议，却让两人之间的较量悄然开始。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20interior%20cinematic%20scene%20with%20warm%20neutral%20tones%2C%20glass%20meeting%20room%2C%20two%20professional%20women%20in%20subtle%20tension%2C%20soft%20daylight%2C%20clean%20composition%2C%20muted%20elegant%20color%20grading&width=800&height=500&seq=mwtn-plot-03&orientation=landscape",
    updatedAt: "2026-05-23",
    content: [
      "第三集把叙事的重心转移到职场线。周芸以空降新人的身份加入苏晴所在的部门，两人第一次正面交锋。",
      "这集最精彩的是那场会议室戏。导演用手持镜头营造出轻微的失衡感，反复在两人的面部特写之间切换。周芸的一句看似寒暄的提问，实则句句带刺。",
      "苏晴的应对同样耐人寻味。她没有正面回击，而是用一份早早准备好的数据让全场安静下来。这个处理让人物形象立刻立体起来——她不是一个只会隐忍的角色。",
      "支线人物王律师在本集首次登场，他手里那份尚未公开的文件，将成为后续剧情的重要引爆点。",
    ],
  },
  {
    id: "plot-4",
    type: "plot",
    title: "被撕掉的那一页日记",
    chapter: "第 4 集",
    tags: ["主线"],
    order: 4,
    summary:
      "顾言回到老家整理旧物，在一本少年时代的日记里，发现整整一页被人撕走，撕痕却整整齐齐。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20shot%20of%20an%20old%20leather%20notebook%20open%20on%20a%20windowsill%20with%20a%20missing%20torn%20page%2C%20soft%20evening%20light%2C%20melancholic%20nostalgic%20atmosphere%2C%20warm%20brown%20and%20cream%20tones%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=mwtn-plot-04&orientation=landscape",
    updatedAt: "2026-05-24",
    content: [
      "第四集是整部剧的第一个小高潮。顾言回到多年未归的老家，在阁楼的箱子里翻出一本少年时代的日记。",
      "日记里的字迹稚嫩，记录着少年顾言的一些琐碎日常。但当他翻到某一页时，画面停住了——那页被人撕走，撕痕却整齐得不像随手而为，更像是有人刻意、仔细地抹去了什么。",
      "这个细节让顾言彻底失眠。他想起十年前的雨夜，想起那个被所有人默契回避的名字。观众也从这里第一次感觉到，所谓的『遗忘』可能并非自然发生，而是被人为安排的。",
      "本集结尾，顾言拨通了一个他多年不敢拨的电话。响了三声，被挂断。他对着空气说了一句『是我不好』。",
    ],
  },
  {
    id: "plot-5",
    type: "plot",
    title: "海边小镇的约定",
    chapter: "第 5 集",
    tags: ["回忆"],
    order: 5,
    summary:
      "一段完整的青春闪回展开：少年时代的苏晴和顾言在海边小镇许下约定，要用一封信守住彼此的将来。",
    cover:
      "https://readdy.ai/api/search-image?query=Golden%20hour%20cinematic%20scene%20of%20two%20young%20people%20walking%20along%20an%20empty%20seaside%20town%20street%2C%20warm%20sunset%20over%20the%20sea%2C%20windy%20and%20nostalgic%20atmosphere%2C%20film%20grain%2C%20soft%20warm%20color%20grading&width=800&height=500&seq=mwtn-plot-05&orientation=landscape",
    updatedAt: "2026-05-25",
    content: [
      "第五集几乎整集都是回忆，时间线回到十年前的海边小镇。这是全剧色调最明亮的一集，满屏都是夕阳的暖橙色。",
      "少年苏晴和少年顾言在码头边的一次长谈构成了本集的核心。两个还没有被生活磨平棱角的年轻人，认真地讨论着将来要去哪里、要成为什么样的人。",
      "他们的约定并不浪漫，甚至有些笨拙——『如果我们走散了，就各自写一封信，寄到那家旧书店。』这个约定正是整部剧的关键信物，也解释了旧书店为何反复出现。",
      "本集结尾回到现在，成年的苏晴站在同一片海边，海还是那片海，只是身边再也没有那个人。这个对比让无数观众破防。",
    ],
  },
  {
    id: "plot-6",
    type: "plot",
    title: "同事之间的试探",
    chapter: "第 6 集",
    tags: ["支线"],
    order: 6,
    summary:
      "一次被迫加班让周芸和苏晴的关系出现微妙变化，两人从对手变成某种意义上的同盟。",
    cover:
      "https://readdy.ai/api/search-image?query=Late%20night%20cinematic%20office%20scene%20with%20two%20women%20working%20overtime%2C%20warm%20desk%20lamps%20against%20dark%20windows%2C%20quiet%20intimate%20atmosphere%2C%20soft%20amber%20lighting%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=mwtn-plot-06&orientation=landscape",
    updatedAt: "2026-05-26",
    content: [
      "第六集放慢了节奏，把镜头对准两个女人之间的深夜加班。整个办公室只剩下两盏台灯，城市在窗外沉默。",
      "周芸第一次卸下了防备，主动给苏晴递了一杯咖啡。她提到了自己也曾失去过重要的人，只是没有说那个人是谁。",
      "这场戏的处理非常细腻，导演几乎不用对白，而是靠两个人的停顿和眼神来完成信息传递。观众能感受到一种不必言明的理解正在建立。",
      "本集也顺带补全了周芸的人物动机，让这个此前略显单薄的角色变得复杂而可信。",
    ],
  },
  {
    id: "plot-7",
    type: "plot",
    title: "生日宴上的真相",
    chapter: "第 7 集",
    tags: ["主线"],
    order: 7,
    summary:
      "顾言母亲的生日宴上，王律师当众宣读了一份尘封的文件，多年来被隐瞒的真相第一次被摊在所有人面前。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20dinner%20party%20scene%20in%20an%20elegant%20dim%20dining%20room%2C%20tense%20confrontation%20among%20family%20members%2C%20warm%20candlelit%20ambience%20contrasting%20cold%20emotions%2C%20deep%20red%20accents%2C%20dramatic%20shadows&width=800&height=500&seq=mwtn-plot-07&orientation=landscape",
    updatedAt: "2026-05-27",
    content: [
      "第七集是全剧最重要的一集，几乎所有此前埋下的线索都在这里交汇。",
      "故事发生在一场看似温馨的生日宴上。觥筹交错之间，王律师突然取出一个牛皮纸档案袋，宣读了一份签署于十年前的协议。",
      "这份文件揭开了一个被所有人刻意隐瞒的事实：十年前那个雨夜发生的事，并不是意外，而是一个各方都在维持的、心照不宣的谎言。",
      "本集的叙事结构非常精巧，导演利用宴席上的三次静场，一层层剥开真相。最后当顾言看向苏晴时，两人眼中都只有疲惫，没有胜利。",
    ],
  },
  {
    id: "plot-8",
    type: "plot",
    title: "写给未来的信",
    chapter: "第 8 集",
    tags: ["主线"],
    order: 8,
    summary:
      "真相之后，没有人真正得到解脱。苏晴写信寄往那家旧书店，而这一次，收信人终于出现了。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20a%20woman%20writing%20a%20letter%20by%20a%20window%20at%20dawn%2C%20soft%20golden%20early%20morning%20light%2C%20quiet%20hopeful%20melancholic%20mood%2C%20warm%20cream%20and%20amber%20tones%2C%20elegant%20composition&width=800&height=500&seq=mwtn-plot-08&orientation=landscape",
    updatedAt: "2026-05-28",
    content: [
      "第八集为第一季画上了一个克制的句号。真相大白之后，生活并没有变得轻松，每个人都带着自己的愧疚继续往前走。",
      "苏晴做了十年来一直没敢做的事：她坐下来，认认真真写了一封信，寄往那家旧书店。信里没有质问，只有平静的叙述。",
      "结尾处，顾言推门走进书店，在柜台前站定。老板递给他一封信，信上的字迹他再熟悉不过。他拆开信，画面停在第一行字上，屏幕渐黑。",
      "这个开放式的结尾引发了观众的大量讨论，也为第二季留下了充分的想象空间。",
    ],
  },
];

export const castItems: CastItem[] = [
  {
    id: "cast-1",
    type: "cast",
    title: "林晚",
    actor: "林晚",
    roleName: "苏晴",
    category: "主演",
    gender: "女演员",
    summary: "饰 苏晴 · 内敛坚韧的图书编辑",
    intro: "以细腻而有层次的表演，塑造了全剧最令人心疼的女主角苏晴。",
    character:
      "苏晴是一名图书编辑，看似平静的日常之下，藏着一段被强行遗忘的过往。她习惯把情绪收进沉默里，只有在旧书与信笺之间，才愿意露出一丝脆弱。",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20headshot%20of%20an%20elegant%20young%20Chinese%20actress%20with%20soft%20gentle%20expression%2C%20warm%20neutral%20lighting%2C%20dark%20muted%20background%2C%20cinematic%20editorial%20style%2C%20high%20detail&width=400&height=400&seq=mwtn-cast-01&orientation=squarish",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20scene%20of%20an%20elegant%20young%20Chinese%20woman%20in%20a%20dim%20library%20surrounded%20by%20old%20books%2C%20warm%20amber%20lighting%2C%20melancholic%20thoughtful%20mood%2C%20soft%20shadows%2C%20artistium%20color%20grading&width=800&height=500&seq=mwtn-cast-01-cover&orientation=landscape",
    bio: [
      "林晚，青年演员，毕业于中央戏剧学院表演系。她以舞台剧出身，擅长用极其克制的方式表现人物的内心波动。",
      "在《我的朋友他的妻子》中，她主动减重以贴近角色的疲惫感，并坚持不用替身完成大部分情绪戏。",
      "拍摄雨夜重逢那场戏时，剧组连续拍摄了三个通宵，林晚全程保持情绪状态，被导演称赞为『把角色活成了自己』。",
      "她曾凭多部文艺题材作品获得业内关注，被媒体称为『最会演沉默的演员』。",
    ],
    updatedAt: "2026-05-24",
  },
  {
    id: "cast-2",
    type: "cast",
    title: "陈默",
    actor: "陈默",
    roleName: "顾言",
    category: "主演",
    gender: "男演员",
    summary: "饰 顾言 · 背负往事的建筑师",
    intro: "用沉静的表演演绎了一个始终迟到的男人，顾言的不完美反而让角色真实。",
    character:
      "顾言是一名建筑师，外表体面而疏离。他习惯用工作填满时间，以此来逃避那段他亲手毁掉的过去。他爱得笨拙，也道歉得笨拙。",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20headshot%20of%20a%20handsome%20young%20Chinese%20actor%20with%20calm%20serious%20expression%2C%20warm%20neutral%20lighting%2C%20dark%20muted%20background%2C%20cinematic%20editorial%20style%2C%20high%20detail&width=400&height=400&seq=mwtn-cast-02&orientation=squarish",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20scene%20of%20a%20handsome%20young%20Chinese%20man%20standing%20by%20a%20rain%20covered%20window%20in%20a%20dim%20room%2C%20warm%20amber%20lighting%2C%20melancholic%20thoughtful%20mood%2C%20soft%20shadows%2C%20elegant%20color%20grading&width=800&height=500&seq=mwtn-cast-02-cover&orientation=landscape",
    bio: [
      "陈默，实力派青年男演员，以塑造内敛复杂的角色著称，近年作品多聚焦现实主义题材。",
      "为了贴近建筑师这一职业，他在开拍前专门到事务所体验生活，学习绘图与看图纸。",
      "他坦言顾言是他演过『最讨厌也最心疼』的角色，因为角色的每一次逃避都能在现实中找到影子。",
      "在片场，他常与导演就人物的动机反复讨论，很多即兴的沉默戏最终被保留在成片里。",
    ],
    updatedAt: "2026-05-24",
  },
  {
    id: "cast-3",
    type: "cast",
    title: "苏芮",
    actor: "苏芮",
    roleName: "周芸",
    category: "主演",
    gender: "女演员",
    summary: "饰 周芸 · 亦敌亦友的职场对手",
    intro: "将周芸的锋芒与柔软拿捏得恰到好处，成为全剧最出彩的配角之一。",
    character:
      "周芸是空降到公司的项目负责人，行事果决，锋芒毕露。她与苏晴的关系从对立走向理解，藏着另一段不为人知的失去。",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20headshot%20of%20a%20confident%20stylish%20young%20Chinese%20woman%20with%20sharp%20elegant%20expression%2C%20warm%20neutral%20lighting%2C%20dark%20muted%20background%2C%20cinematic%20editorial%20style%2C%20high%20detail&width=400&height=400&seq=mwtn-cast-03&orientation=squarish",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20scene%20of%20a%20confident%20young%20Chinese%20businesswoman%20in%20a%20dim%20modern%20office%20at%20night%2C%20warm%20amber%20desk%20lamp%20lighting%2C%20composed%20intense%20mood%2C%20soft%20shadows%2C%20elegant%20color%20grading&width=800&height=500&seq=mwtn-cast-03-cover&orientation=landscape",
    bio: [
      "苏芮，话剧演员出身，台词功底扎实，擅长塑造强势而层次丰富的女性角色。",
      "她为周芸设计了许多小动作，比如说话时下意识转动钢笔，用来外化角色内心的紧张。",
      "剧中她与林晚的多场对手戏被认为是全剧演技高光，尤其是深夜加班那场几乎没有台词的戏。",
      "苏芮表示，周芸最大的魅力在于她从不自证清白，只是安静地做自己该做的事。",
    ],
    updatedAt: "2026-05-25",
  },
  {
    id: "cast-4",
    type: "cast",
    title: "高远",
    actor: "高远",
    roleName: "陆时衍",
    category: "主演",
    gender: "男演员",
    summary: "饰 陆时衍 · 看似可靠的旧友",
    intro: "以温和外表包裹复杂内心，陆时衍这个角色直到第七集才露出真面目。",
    character:
      "陆时衍是顾言的多年好友，也是那场生日宴的召集人。他永远站在最得体的位置上，说最合适的话——直到真相被揭开。",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20headshot%20of%20a%20mature%20composed%20Chinese%20man%20with%20a%20subtle%20smile%2C%20warm%20neutral%20lighting%2C%20dark%20muted%20background%2C%20cinematic%20editorial%20style%2C%20high%20detail&width=400&height=400&seq=mwtn-cast-04&orientation=squarish",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20scene%20of%20a%20composed%20mature%20Chinese%20man%20in%20an%20elegant%20dim%20library%2C%20warm%20amber%20lighting%2C%20enigmatic%20calm%20mood%2C%20soft%20shadows%2C%20refined%20color%20grading&width=800&height=500&seq=mwtn-cast-04-cover&orientation=landscape",
    bio: [
      "高远，从业二十余年的资深演员，素以塑造『看似平凡实则关键』的角色见长。",
      "他形容陆时衍是『一个把善意的谎言讲了一辈子的人』，因此在表演时刻意不给任何反派式的暗示。",
      "第七集生日宴上的那段独白，他坚持一条过，认为角色在那样的时刻不会有太多表演的余地。",
      "导演评价他：『他把一个可能的反派，演成了一个让人恨不起来的人。』",
    ],
    updatedAt: "2026-05-26",
  },
  {
    id: "cast-5",
    type: "cast",
    title: "何静",
    actor: "何静",
    roleName: "苏母",
    category: "配角",
    gender: "女演员",
    summary: "饰 苏母 · 沉默的守护者",
    intro: "戏份不多却分量极重，她把一个母亲的隐忍演得不着痕迹。",
    character:
      "苏母一生沉默，用最朴素的方式守护着女儿。她留下的那封旧信，成为推动整个故事的关键。",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20studio%20portrait%20headshot%20of%20a%20gentle%20older%20Chinese%20woman%20with%20kind%20tired%20eyes%2C%20soft%20neutral%20lighting%2C%20dark%20muted%20background%2C%20cinematic%20editorial%20style%2C%20high%20detail&width=400&height=400&seq=mwtn-cast-05&orientation=squarish",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20a%20gentle%20older%20Chinese%20woman%20sitting%20by%20a%20sunlit%20window%20in%20a%20quiet%20old%20room%2C%20warm%20afternoon%20light%2C%20nostalgic%20peaceful%20mood%2C%20soft%20shadows%2C%20warm%20color%20grading&width=800&height=500&seq=mwtn-cast-05-cover&orientation=landscape",
    bio: [
      "何静，资深演员，长期活跃于家庭题材作品中，被认为是最会演『母亲』的演员之一。",
      "在剧中她只有寥寥数场戏，但每一场都成为推动剧情的关键节点。",
      "她坚持不把苏母演成苦情形象，而是让这个角色保留一种体面的克制。",
      "导演说她进组第一天就定下了全剧的情感基调。",
    ],
    updatedAt: "2026-05-24",
  },
  {
    id: "cast-6",
    type: "cast",
    title: "赵行",
    actor: "赵行",
    roleName: "王律师",
    category: "配角",
    gender: "男演员",
    summary: "饰 王律师 · 真相的宣读者",
    intro: "一个手持关键文件的中年律师，他的出现彻底改变了故事的走向。",
    character:
      "王律师受托保管着一份十年前的协议，多年来他始终守口如瓶，直到那一刻他认为时机已到。",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20headshot%20of%20a%20serious%20middle%20aged%20Chinese%20man%20in%20a%20suit%2C%20warm%20neutral%20lighting%2C%20dark%20muted%20background%2C%20cinematic%20editorial%20style%2C%20high%20detail&width=400&height=400&seq=mwtn-cast-06&orientation=squarish",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20a%20serious%20middle%20aged%20Chinese%20lawyer%20holding%20a%20document%20folder%20in%20a%20dim%20corridor%2C%20warm%20amber%20lighting%2C%20tense%20quiet%20mood%2C%20soft%20shadows%2C%20muted%20color%20grading&width=800&height=500&seq=mwtn-cast-06-cover&orientation=landscape",
    bio: [
      "赵行，以出演职业剧中的专业角色而被观众熟知，表演沉稳、可信度高。",
      "为了准确把握律师宣读文件的状态，他在片场反复调整语速，最终呈现出一种近乎冷酷的平静。",
      "他认为王律师并非推动剧情，而是剧情发展到此必然出现的那个人。",
      "第七集的那场宣读戏，是整部剧拍摄难度最高的一场群戏。",
    ],
    updatedAt: "2026-05-26",
  },
  {
    id: "cast-7",
    type: "cast",
    title: "白露",
    actor: "白露",
    roleName: "少年苏晴",
    category: "特邀",
    gender: "女演员",
    summary: "饰 少年苏晴 · 回忆线女主角",
    intro: "新人演员，用干净的眼神演出了青春线里最明亮也最遗憾的部分。",
    character:
      "少年苏晴生活在海边小镇，相信约定、相信未来，也相信那个说要一起写信的男孩。",
    avatar:
      "https://readdy.ai/api/search-image?query=Fresh%20natural%20studio%20portrait%20headshot%20of%20a%20young%20Chinese%20girl%20with%20clear%20bright%20eyes%20and%20soft%20smile%2C%20warm%20neutral%20lighting%2C%20light%20muted%20background%2C%20cinematic%20editorial%20style%2C%20high%20detail&width=400&height=400&seq=mwtn-cast-07&orientation=squarish",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20a%20young%20Chinese%20girl%20standing%20by%20the%20sea%20at%20golden%20hour%2C%20wind%20in%20her%20hair%2C%20bright%20hopeful%20nostalgic%20mood%2C%20warm%20sunset%20color%20grading%2C%20film%20grain&width=800&height=500&seq=mwtn-cast-07-cover&orientation=landscape",
    bio: [
      "白露，表演系在校学生，这是她首次参与电视剧拍摄。",
      "为了贴近小镇少女的感觉，她提前两周住进拍摄地，学习当地方言与生活习惯。",
      "海边约定那场戏全部在自然光下拍摄，她与搭档几乎没有排练，全靠真实反应。",
      "她说少年苏晴让她想起了自己的十七岁，那是一种再也回不去的心动。",
    ],
    updatedAt: "2026-05-25",
  },
  {
    id: "cast-8",
    type: "cast",
    title: "顾南",
    actor: "顾南",
    roleName: "少年顾言",
    category: "特邀",
    gender: "男演员",
    summary: "饰 少年顾言 · 回忆线男主角",
    intro: "新人男演员，把少年顾言的笨拙与勇敢刻画得格外动人。",
    character:
      "少年顾言沉默寡言，却愿意为一个人认真写下长长的信。他相信只要写信，就不会真的走散。",
    avatar:
      "https://readdy.ai/api/search-image?query=Fresh%20natural%20studio%20portrait%20headshot%20of%20a%20young%20Chinese%20boy%20with%20calm%20sincere%20expression%2C%20warm%20neutral%20lighting%2C%20light%20muted%20background%2C%20cinematic%20editorial%20style%2C%20high%20detail&width=400&height=400&seq=mwtn-cast-08&orientation=squarish",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20a%20young%20Chinese%20boy%20walking%20along%20an%20empty%20seaside%20road%20at%20golden%20hour%2C%20quiet%20nostalgic%20mood%2C%20warm%20sunset%20color%20grading%2C%20film%20grain&width=800&height=500&seq=mwtn-cast-08-cover&orientation=landscape",
    bio: [
      "顾南，就读于表演系，因气质干净而被选中出演少年顾言。",
      "他在拍摄前认真研读了剧本中所有与顾言相关的段落，并写下了人物小传。",
      "码头长谈那场戏，导演要求一条过，他与白露在夕阳下完成了整段对话。",
      "顾南表示，少年顾言让他明白，有些约定之所以珍贵，正是因为它们最终没有实现。",
    ],
    updatedAt: "2026-05-25",
  },
];

export const reviewItems: ReviewItem[] = [
  {
    id: "review-1",
    type: "review",
    title: "在遗忘与铭记之间：《我的朋友他的妻子》的情感叙事",
    author: "影评人 · 南山",
    date: "2026-06-02",
    tags: ["剧情分析"],
    popularity: 9850,
    summary:
      "这部剧真正想讲的不是爱情，而是人如何在漫长的岁月里，一点点学会与自己和解。",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20still%20of%20an%20empty%20seat%20by%20a%20rainy%20window%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20reflective%20melancholic%20mood%2C%20soft%20shadows%2C%20elegant%20composition&width=800&height=500&seq=mwtn-review-01&orientation=landscape",
    content: [
      "《我的朋友他的妻子》最容易被误解的地方，是它被当成一部普通的都市情感剧来讨论。但只要看到第五集海边约定那段闪回，你就会意识到，导演真正关心的从来不是『他们能不能在一起』。",
      "这部剧的核心命题是记忆。它反复追问一个问题：当我们选择遗忘一些事，究竟是为了保护自己，还是为了保护别人？十年前那个雨夜，所有当事人都默契地选择了沉默，而沉默本身，就是这部剧最大的悬念。",
      "镜头语言的克制是这部剧的底气。大量固定机位与长镜头，让人物的沉默被完整保留下来。雨夜重逢那三秒钟，导演没有给任何配乐，只有雨声——这种处理在当下追求快节奏的剧集里几乎是一种冒险。",
      "所以与其说这是一部爱情剧，不如说它是一部关于『迟到』的作品。顾言迟到了十年才敢道歉，苏晴迟到了十年才肯落泪，而那些被撕去的、被烧掉的、被藏起来的真相，也迟到了十年才被看见。",
    ],
  },
  {
    id: "review-2",
    type: "review",
    title: "苏晴这个角色为什么如此令人心疼",
    author: "剧迷 · 小鹿",
    date: "2026-06-05",
    tags: ["人物点评"],
    popularity: 8720,
    summary:
      "她几乎从不爆发，所有的痛都被她咽了回去，而这恰恰是最让人无法平静的地方。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20quiet%20woman%20reading%20by%20a%20lamp%20in%20a%20dim%20warm%20room%20at%20night%2C%20deep%20amber%20tones%2C%20intimate%20melancholic%20mood%2C%20soft%20shadows%2C%20elegant%20refined%20composition&width=800&height=500&seq=mwtn-review-02&orientation=landscape",
    content: [
      "看完整个第一季，我最想聊的不是顾言，而是苏晴。因为她代表了一种我们很少在电视剧里看到的女性形象——不解释、不控诉、不表演痛苦。",
      "苏晴这个角色几乎全程处于被动。她整理母亲的遗物、面对空降的对手、被卷进一场她并不想参与的真相。但正是这种被动，让她每一次微小的主动都显得格外珍贵，比如她最终决定写那封信。",
      "林晚的表演为角色加了很多分。她懂得在什么时候什么都不做。第三集会议室那场戏，她全程只用了一个眼神，就把『我早准备好了』说清楚了。",
      "最让我难忘的是第八集，她坐在清晨的窗前写信那一幕。阳光从窗缝里进来，她的手在微微发抖，但字迹很稳。那一刻你会明白，所谓成长，就是明明还会痛，却依然选择把话说完。",
    ],
  },
  {
    id: "review-3",
    type: "review",
    title: "从镜头语言看这部剧的野心",
    author: "光影笔记",
    date: "2026-06-08",
    tags: ["剧情分析"],
    popularity: 7610,
    summary:
      "把都市情感剧拍出了电影质感，导演在构图与色彩的运用上埋了大量小心思。",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20composition%20of%20light%20and%20shadow%20on%20an%20old%20wall%20with%20a%20window%20frame%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20abstract%20moody%20elegant%20atmosphere%2C%20film%20grain&width=800&height=500&seq=mwtn-review-03&orientation=landscape",
    content: [
      "如果说演技是这部剧的门面，那么镜头语言才是它真正的骨相。整部剧的构图意识极强，几乎每一帧都经得起暂停细看。",
      "最典型的是『门与窗』的意象。几乎每一个重要转折，导演都会让人物站在门框或窗框之内，暗示他们被某种东西限制着。第一个雨夜，苏晴就站在书店门口——她始终没有走进那扇门。",
      "色彩同样在叙事。回忆线是暖橙色的夕阳与海风，而现在线则被压成偏冷的灰与暗红。两条时间线无需字幕提示，观众就能凭色调判断身处何时。",
      "第三集之后频繁出现的手持镜头也值得一说。它只在人物内心失衡时出现，一旦情绪平复，镜头又回到稳定的固定机位。这种规律本身就是一种叙事。",
    ],
  },
  {
    id: "review-4",
    type: "review",
    title: "观众热议：结局到底意味着什么",
    author: "观众投稿",
    date: "2026-06-11",
    tags: ["观众反馈"],
    popularity: 9340,
    summary:
      "开放式结局引发大量讨论，有人认为释然，有人认为残忍，我们整理了三种主流解读。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20an%20open%20old%20bookstore%20door%20with%20warm%20light%20spilling%20out%20at%20dusk%2C%20deep%20amber%20and%20red%20tones%2C%20hopeful%20yet%20bittersweet%20mood%2C%20soft%20shadows&width=800&height=500&seq=mwtn-review-04&orientation=landscape",
    content: [
      "第八集结尾，顾言在旧书店拆开那封信，画面停在第一行字上就切黑了。这个处理让观众吵翻了天。",
      "第一种解读是『释然』。他们认为，拆开信这个动作本身就是答案——无论信里写了什么，顾言终于愿意面对，这已经是一种和解。",
      "第二种解读是『残忍』。他们认为导演故意不让我们看到内容，是因为信里的话并不温柔。苏晴等的是道歉，而她要的从来不是原谅。",
      "第三种解读更有意思：这封信是一场新的开始。第一季讲的是遗忘，那么第二季或许会讲重新认识。已备案的第二季印证了这个方向。",
      "无论哪种解读，可以确定的是，这个结局没有讨好任何人，它只是诚实地停在了一个人愿意面对自己的时刻。",
    ],
  },
  {
    id: "review-5",
    type: "review",
    title: "配乐如何撑起全剧的情绪",
    author: "乐评人 · 乔木",
    date: "2026-06-14",
    tags: ["剧情分析"],
    popularity: 6480,
    summary:
      "全剧只有四段主题旋律，却在不同场景中被反复变形，成为叙事的第二语言。",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20still%20of%20an%20old%20vintage%20radio%20and%20sheet%20music%20on%20a%20wooden%20table%2C%20warm%20amber%20lighting%2C%20nostalgic%20quiet%20mood%2C%20soft%20shadows%2C%20elegant%20composition&width=800&height=500&seq=mwtn-review-05&orientation=landscape",
    content: [
      "很多人讨论这部剧时会忽略配乐，但恰恰是配乐，决定了观众何时会破防。",
      "整部剧的原创配乐其实非常节制，主要主题旋律只有四段。它们在不同的场景里被重新编曲、变奏，有时用钢琴，有时用弦乐，有时甚至只是几个单音。",
      "最巧妙的是回忆线与现在线共用同一段旋律，只是调式不同。暖色回忆用的是大调，而现在线全部转为小调。观众未必意识到这一点，但一定会感到那种『熟悉的陌生』。",
      "雨夜重逢那场戏，导演选择完全不用配乐，只有雨声与远处的车流。这反而成了全剧最被记住的一个『音乐时刻』——因为沉默本身就是最好的配乐。",
    ],
  },
  {
    id: "review-6",
    type: "review",
    title: "顾言：一个不完美的成年人的自白",
    author: "角色研究所",
    date: "2026-06-17",
    tags: ["人物点评"],
    popularity: 7130,
    summary:
      "他不值得被原谅，但值得被理解。顾言身上有太多成年人的影子。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20lonely%20man%20sitting%20alone%20in%20a%20dim%20apartment%20at%20night%20looking%20out%20the%20window%2C%20warm%20amber%20lamp%20against%20cold%20blue%20dusk%2C%20melancholic%20quiet%20mood%2C%20soft%20shadows&width=800&height=500&seq=mwtn-review-06&orientation=landscape",
    content: [
      "顾言这个角色引起了很多争议，因为他不讨喜。他逃避、他沉默、他在最重要的时刻选择转身离开。但恰恰是这种不讨喜，让他显得真实。",
      "编剧的高明之处在于，她没有给顾言任何为自己辩解的机会。他所有的歉意都只能通过行动表达，而他的行动又总是慢半拍。",
      "第四集那个被撕掉的日记页，其实是顾言这个人物的缩影。他不是忘记，而是不敢记得。承认记忆，就意味着承认自己曾经的懦弱。",
      "所以到最后，我无法说我原谅了顾言。但我理解他。因为在现实里，我们当中的很多人，也曾在某个雨夜选择闭上嘴巴，然后用了十年的时间去后悔。",
    ],
  },
];

export const newsItems: NewsItem[] = [
  {
    id: "news-1",
    type: "news",
    title: "《我的朋友他的妻子》正式定档 5 月 20 日",
    date: "2026-04-18",
    summary: "官方宣布该剧将于 5 月 20 日起播出，并同步释出首版预告与主视觉海报。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20announcement%20key%20visual%20of%20a%20dramatic%20portrait%20with%20deep%20red%20and%20amber%20tones%2C%20elegant%20moody%20atmosphere%2C%20film%20poster%20composition%2C%20no%20text&width=600&height=400&seq=mwtn-news-01&orientation=landscape",
    content: [
      "官方于 4 月 18 日正式宣布，都市情感剧《我的朋友他的妻子》定档 5 月 20 日与观众见面。",
      "同步释出的主视觉海报以深红与暖橙为主色，画面中两个背对而立的身影暗示了剧中复杂的人物关系，引发大量转发讨论。",
      "此外，官方还公布了首版 60 秒预告片，短短一分钟内抛出了『雨夜』『旧信』『被撕掉的日记』等多个悬念。",
      "制片方表示，本剧希望用更克制的方式呈现一段关于记忆与和解的故事，期待观众在追剧过程中愿意停下来思考。",
    ],
    updatedAt: "2026-04-18",
  },
  {
    id: "news-2",
    type: "news",
    title: "官方发布首支预告片，悬念感拉满",
    date: "2026-04-25",
    summary: "一分钟预告连续抛出多个关键悬念，结尾一闪而过的信笺镜头成为讨论焦点。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20teaser%20style%20visual%20of%20rain%20on%20a%20window%20with%20warm%20light%20behind%20it%2C%20deep%20amber%20and%20red%20tones%2C%20mysterious%20emotional%20mood%2C%20film%20grain&width=600&height=400&seq=mwtn-news-02&orientation=landscape",
    content: [
      "4 月 25 日，《我的朋友他的妻子》首支正式预告片上线。",
      "预告片以一场大雨开场，随后快速剪辑了多个关键场景：旧书店门口的对望、落满灰的木箱、被撕掉一页的日记本。",
      "最受关注的是预告片结尾那个一闪而过的镜头——一封没有寄出的信。大量网友在评论区猜测这封信的收信人究竟是谁。",
      "片方透露，预告片中出现的每一个道具都不是闲笔，它们都会在正片中起到关键作用。",
    ],
    updatedAt: "2026-04-25",
  },
  {
    id: "news-3",
    type: "news",
    title: "主创团队亮相发布会，分享拍摄幕后",
    date: "2026-05-02",
    summary: "导演与主演出席开播发布会，分享了雨夜戏连拍三个通宵的幕后故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20press%20conference%20stage%20visual%20with%20warm%20spotlights%20and%20deep%20red%20backdrop%2C%20elegant%20formal%20atmosphere%2C%20soft%20shadows%2C%20no%20text&width=600&height=400&seq=mwtn-news-03&orientation=landscape",
    content: [
      "5 月 2 日，《我的朋友他的妻子》开播发布会在京举行，导演沈聿携主演林晚、陈默、苏芮等亮相。",
      "发布会上，导演分享了第一集雨夜重逢那场戏的拍摄过程：剧组连续拍摄了三个通宵，只为捕捉最真实的雨幕质感。",
      "主演林晚提到，为了贴近角色的疲惫状态，她在拍摄前期主动调整了作息与饮食。",
      "当被问及本剧最大的看点时，导演回答：『不是反转，而是沉默。』",
    ],
    updatedAt: "2026-05-02",
  },
  {
    id: "news-4",
    type: "news",
    title: "剧集首周收视登顶，口碑持续走高",
    date: "2026-05-21",
    summary: "开播首周即登顶同时段收视榜首，社交平台相关话题阅读量突破 10 亿。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20celebration%20visual%20with%20warm%20golden%20light%20rays%20and%20deep%20red%20accents%2C%20elegant%20triumphant%20atmosphere%2C%20soft%20glow%2C%20abstract%20no%20text&width=600&height=400&seq=mwtn-news-04&orientation=landscape",
    content: [
      "该剧自 5 月 20 日开播以来，首周便登顶同时段收视榜首。",
      "据平台统计，与剧集相关的社交话题总阅读量已突破 10 亿，多个剧集片段登上热搜。",
      "不少观众表示，本剧最打动人的地方在于『不刻意催泪，却处处是泪点』。",
      "评分方面，该剧开分 8.5，随着剧情推进，目前稳定在 8.7 分并仍有上升趋势。",
    ],
    updatedAt: "2026-05-21",
  },
  {
    id: "news-5",
    type: "news",
    title: "导演确认将推出幕后特辑",
    date: "2026-05-28",
    summary: "官方确认将制作幕后纪录片，完整呈现雨夜戏、海边戏等高难度场景的拍摄过程。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20visual%20of%20a%20film%20camera%20and%20warm%20studio%20lights%2C%20deep%20red%20and%20amber%20tones%2C%20professional%20atmosphere%2C%20soft%20shadows%2C%20no%20text&width=600&height=400&seq=mwtn-news-05&orientation=landscape",
    content: [
      "导演沈聿在采访中确认，剧组正在制作一支幕后特辑，预计将在本季完结后上线。",
      "特辑将完整呈现多个高难度场景的拍摄过程，包括第一集的雨夜重逢、第五集的海边约定以及第七集的生日宴群戏。",
      "制作团队表示，希望让观众看到『每一帧克制背后，其实是极其繁复的准备』。",
      "此外，特辑中还将收录部分被剪掉的片段，以及主创的创作手记。",
    ],
    updatedAt: "2026-05-28",
  },
  {
    id: "news-6",
    type: "news",
    title: "剧组释出角色海报高清剧照",
    date: "2026-06-05",
    summary: "官方一次性发布八位主要角色的单人海报，每张都暗藏与人物命运相关的小细节。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20wall%20visual%20with%20multiple%20dramatic%20portrait%20frames%20in%20deep%20red%20and%20amber%20tones%2C%20elegant%20moody%20gallery%20atmosphere%2C%20soft%20shadows%2C%20no%20text&width=600&height=400&seq=mwtn-news-06&orientation=landscape",
    content: [
      "6 月 5 日，官方发布了八位主要角色的单人海报，覆盖苏晴、顾言、周芸、陆时衍等核心人物。",
      "值得一提的是，每张海报都暗藏与人物命运相关的小细节：苏晴手中握着旧书，顾言站在窗前，周芸则背对镜头。",
      "美术团队透露，海报的光影方向与角色在剧中的立场相对应，观众可以留意这一点。",
      "海报发布后迅速引发二次创作热潮，不少网友开始分析画面中的隐藏线索。",
    ],
    updatedAt: "2026-06-05",
  },
  {
    id: "news-7",
    type: "news",
    title: "主演接受专访：谈角色塑造",
    date: "2026-06-12",
    summary: "林晚与陈默接受媒体专访，深度分享了各自对角色和剧中情感关系的理解。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20interview%20set%20visual%20with%20two%20warm%20studio%20chairs%20and%20soft%20amber%20lighting%2C%20intimate%20conversational%20atmosphere%2C%20deep%20red%20backdrop%20tones%2C%20no%20text&width=600&height=400&seq=mwtn-news-07&orientation=landscape",
    content: [
      "在最新的媒体专访中，林晚与陈默首次正面回应了观众对两个角色的各种讨论。",
      "林晚表示，苏晴最难演的其实不是崩溃，而是『忍住不崩溃』。她认为这部剧真正尊重了人物的沉默。",
      "陈默则坦言顾言是他演过最不讨喜的角色，但他坚持要演，因为『生活里大多数人都不是完美的』。",
      "当被问及如果重新选择会怎样，两人异口同声：『还是会让他们错过。』",
    ],
    updatedAt: "2026-06-12",
  },
  {
    id: "news-8",
    type: "news",
    title: "第二季备案立项，原班人马有望回归",
    date: "2026-06-20",
    summary: "据公开信息显示，该剧第二季已完成立项备案，主创团队原班人马回归的可能性较大。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20hopeful%20visual%20of%20a%20bookstore%20door%20opening%20to%20warm%20golden%20light%2C%20deep%20amber%20and%20red%20tones%2C%20bittersweet%20optimistic%20atmosphere%2C%20soft%20glow%2C%20no%20text&width=600&height=400&seq=mwtn-news-08&orientation=landscape",
    content: [
      "据公开备案信息显示，《我的朋友他的妻子》第二季已完成立项，进入前期筹备阶段。",
      "虽然官方尚未正式官宣阵容，但多方信息显示原班人马回归的可能性较大。",
      "考虑到第一季结尾的开放式处理，第二季有望继续围绕苏晴与顾言的故事展开。",
      "制片方在回应中表示：『如果第一季讲的是遗忘，那么下一次我们想聊聊重新认识。』",
    ],
    updatedAt: "2026-06-20",
  },
];

export const recommendations: Recommendation[] = [
  {
    id: "rec-1",
    title: "《雾里归途》",
    subtitle: "悬疑 · 都市 · 情感",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20moody%20poster%20style%20image%20of%20a%20lonely%20figure%20walking%20through%20foggy%20city%20streets%20at%20dusk%2C%20cool%20blue%20grey%20with%20warm%20amber%20accents%2C%20mysterious%20emotional%20atmosphere%2C%20film%20grain%2C%20no%20text&width=400&height=560&seq=mwtn-rec-01&orientation=portrait",
    link: "/category/plot",
  },
  {
    id: "rec-2",
    title: "《旧书店的夏天》",
    subtitle: "文艺 · 治愈 · 青春",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20warm%20poster%20style%20image%20of%20a%20sunlit%20vintage%20bookstore%20interior%20with%20rows%20of%20old%20books%2C%20golden%20afternoon%20light%2C%20cozy%20nostalgic%20atmosphere%2C%20warm%20amber%20tones%2C%20film%20grain%2C%20no%20text&width=400&height=560&seq=mwtn-rec-02&orientation=portrait",
    link: "/category/reviews",
  },
  {
    id: "rec-3",
    title: "《未寄出的信》",
    subtitle: "爱情 · 剧情 · 催泪",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20style%20image%20of%20a%20handwritten%20letter%20and%20a%20dried%20flower%20on%20a%20dim%20wooden%20table%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20melancholic%20nostalgic%20atmosphere%2C%20film%20grain%2C%20no%20text&width=400&height=560&seq=mwtn-rec-03&orientation=portrait",
    link: "/category/plot",
  },
  {
    id: "rec-4",
    title: "《海边的约定》",
    subtitle: "青春 · 成长 · 治愈",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20style%20image%20of%20a%20seaside%20town%20at%20golden%20hour%20with%20two%20distant%20silhouettes%2C%20warm%20sunset%20tones%2C%20hopeful%20nostalgic%20atmosphere%2C%20film%20grain%2C%20no%20text&width=400&height=560&seq=mwtn-rec-04&orientation=portrait",
    link: "/category/cast",
  },
];

export const allContent = [
  ...plotItems,
  ...castItems,
  ...reviewItems,
  ...newsItems,
];

export function findContentById(id: string) {
  return allContent.find((item) => item.id === id);
}

export const plotTags = ["全部", "主线", "支线", "回忆"];
export const reviewTags = ["全部", "剧情分析", "人物点评", "观众反馈"];
export const castCategories = ["全部", "主演", "配角", "特邀"] as const;
export const castGenders = ["全部", "男演员", "女演员"];